import * as appActions from '../actions/app.actions';

export interface UiState {
  currentTitle: string;
}

export const INIT_UI_STATE: UiState = {
  currentTitle: undefined
};


export function reducer(state: UiState = INIT_UI_STATE, {type, payload}: appActions.AuthActions): UiState {

  switch (type) {

    case appActions.AuthActionTypes.SET_CURRENT_TITLE: {
      return { ...state, currentTitle: payload};
    }

    default : {
      return state;
    }
  }
}



// SELECTORS
export const getCurrentTitle = (state: UiState) => state.currentTitle;
